import { DocumentNode, gql } from '@apollo/client';
import { Heading, Stack, VStack } from '@chakra-ui/react';
import { ContentState, EditorState, convertFromRaw } from 'draft-js';
import * as React from 'react';

import { Redraft } from '@/components/Redraft';
import { Resources } from '@/components/Resources';
import { RecentActivityCard } from '@/components/organizations/components/RecentActivityCard';
import { Card } from '@/imports/ui/chakra/components/Card';
import { Prose } from '@/imports/ui/chakra/components/Prose';
import { PlatformContextPreviewLink } from '@/imports/ui/components/context/PlatformContextPreviewLink/PlatformContextPreviewLink';
import { useLinkPreview } from '@/imports/ui/components/context/PlatformContextPreviewLink/useLinkPreview';

import { OverviewContent_OrganizationFragment } from './graphql-types/OverviewContent_OrganizationFragment';

export const Content: React.FC<{
  organization: OverviewContent_OrganizationFragment;
}> & {
  organizationFragment: DocumentNode;
} = ({ organization }) => {
  const [editorState] = React.useState<EditorState>(
    EditorState.createWithContent(
      organization.aboutUs
        ? convertFromRaw(organization.aboutUs)
        : ContentState.createFromText('')
    )
  );

  const { linkPreview } = useLinkPreview({
    editorState,
    onHidePreviewHandler: () => null,
  });

  return (
    <VStack spacing="4" mb="4">
      {organization.aboutUs &&
      convertFromRaw(organization.aboutUs).hasText() ? (
        <Card w="full" px="4" py="6">
          <Heading size="md" mb="4">
            About Us
          </Heading>

          <Stack spacing="4">
            <Prose>
              <Redraft rawDraftContentState={organization.aboutUs} />
            </Prose>

            <PlatformContextPreviewLink
              linkPreview={linkPreview}
              canEdit={false}
              onClose={() => null}
            />

            <Resources
              organizationId={organization._id}
              alt={organization.displayName}
            />
          </Stack>
        </Card>
      ) : null}

      <RecentActivityCard organization={organization} />
    </VStack>
  );
};
Content.organizationFragment = gql`
  fragment OverviewContent_OrganizationFragment on Organization {
    _id
    aboutUs
    displayName
    ...RecentActivityCard_OrganizationFragment
  }
  ${RecentActivityCard.organizationFragment}
`;
